// stats.js — Observatoire d'une ville. Paris (/stats) : DB Paris courante
// (dist-analytics/data/*.json, copies par build.py dans /data/stats/).
// Pas d'archives historiques : lecture plus simple, cadence unique (meme fenetre que
// la prod v1). Meme pattern que V1 : JSON statiques batis en CI.
//
// Les autres villes (/lyon/stats/, page de generate_city_pages.py qui porte
// <meta name="lagenda-ville">) lisent /data/stats/villes/<slug>/ : les memes
// 13 fichiers, memes champs, calcules sur l'agenda public de province
// (scrapers/stats_villes.py). Leurs salles viennent de js/villes.js
// (sallesDeLaVille) ; le bloc « Par arrondissement » y devient « Par commune ».
// Sans index des villes (villes.js muet), la page reste l'observatoire de Paris.
(function(){
'use strict';

const DATA_PARIS = '/data/stats/';
const PAGE_VILLE = (document.querySelector('meta[name="lagenda-ville"]') || {}).content || null;
let VILLE = null;   // ville de la page ({slug, nom, a_nom…}) ; null = Paris
let VENUES = [];    // salles de la page : VENUES_DATA a Paris, celles de la ville ailleurs

// Couleurs des salles d'une ville : celles des salles de Paris (venues-data.js),
// chaudes et froides en alternance, la plus active en braise.
const CITY_PALETTE = ['#E8562C','#5E9DB6','#F59E32','#6B9A7E','#B96F9A','#C9A44B','#7BA9A6','#D4623F','#8A9A4F','#E87A62','#9C9AA6','#CFB065','#D97757'];
const CONFIGS = {debout:'Debout', assis:'Assis', modulable:'Modulable'};

const esc = s => (s==null?'':String(s)).replace(/[&<>"']/g, c => ({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c]));

// ===== VENUES =====
const V_BY_NAME = {};
const V_BY_SLUG = {};
function indexVenues(list){
  VENUES = list;
  list.forEach(v => {
    V_BY_SLUG[v.slug] = v;
    (v.names || [v.dbName]).forEach(n => { V_BY_NAME[n.toLowerCase()] = v; });
    V_BY_NAME[v.dbName.toLowerCase()] = v;
  });
}

// Salles d'une ville, au format de VENUES_DATA. Celles de villes.json d'abord ;
// puis celles que l'historique compte encore sans date a venir (absentes de
// villes.json, decrites par meta.salles).
function cityVenues(){
  const extra = (STATE.data.meta || {}).salles || {};
  const list = window.LAgendaVilles.sallesDeLaVille().map(s => ({
    venue:s.venue, nom:s.nom, slug:s.slug, capacite:s.capacite, commune:s.commune,
    adresse:s.adresse, configuration:s.configuration
  }));
  const known = new Set(list.map(s => s.venue));
  Object.keys(extra).forEach(name => {
    if(!known.has(name)) list.push({venue:name, nom:name, slug:null, capacite:extra[name].capacite, commune:extra[name].commune});
  });
  const vol = {};
  (STATE.data.sold_out_by_venue || []).forEach(r => { vol[r.venue] = r.total_events || 0; });
  list.sort((a,b) => (vol[b.venue]||0) - (vol[a.venue]||0) || String(a.nom).localeCompare(String(b.nom), 'fr'));
  return list.map((s,i) => ({
    slug: s.slug || ('salle-' + i), dbName: s.venue, names: [s.venue], display: s.nom || s.venue,
    hex: CITY_PALETTE[i % CITY_PALETTE.length], capacity: s.capacite || null,
    postal: null, commune: s.commune || '', street: s.adresse || '', type: CONFIGS[s.configuration] || ''
  }));
}

// Zone d'une salle pour le filtre geographique : arrondissement a Paris
// (code postal), commune ailleurs.
function zoneOf(v){ return VILLE ? (v.commune || '') : v.postal; }
function zoneAllLabel(){ return VILLE ? 'Toutes' : 'Tous'; }

function resolveVenue(name){
  if(!name) return null;
  return V_BY_NAME[name.toLowerCase()] || null;
}

// ===== STATE =====
const STATE = {
  period: 'total',       // total | future
  genre: null,
  sort: 'volume',        // volume | soldout | capacity
  prodSort: 'volume',    // volume | soldout | reach
  scope: 'all',          // all | sold
  hmMode: 'count',
  arr: 'all',
  focusSlug: null,
  data: {},
  today: new Date()
};

// ===== HELPERS =====
const MONTHS_LBL = ['Jan','Fév','Mar','Avr','Mai','Juin','Juil','Août','Sept','Oct','Nov','Déc'];
const DAYS_LBL = ['Lun','Mar','Mer','Jeu','Ven','Sam','Dim'];

function fmt(n){ return (n==null||isNaN(n)) ? '—' : Number(n).toLocaleString('fr-FR'); }
function ymd(d){ return d.toISOString().slice(0,10); }

// ===== LOAD =====
async function loadJSON(base, name){
  try {
    const r = await fetch(base + name, {cache:'default'});
    if(!r.ok) throw new Error(r.status);
    return await r.json();
  } catch(e){
    console.warn('[stats] miss:', name, e.message);
    return null;
  }
}
async function loadAll(base){
  const files = [
    'kpi_global','meta','seasonality','sold_out_by_venue','weekly_distribution',
    'venue_day_matrix','daily_heatmap','genre_sold_out','genre_by_venue','genre_by_month',
    'top_headliners','producer_market_share','producer_venue_share'
  ];
  const pairs = await Promise.all(files.map(async f => [f, await loadJSON(base, f+'.json')]));
  return Object.fromEntries(pairs);
}

// Ville de la page, ou null pour Paris. Sans meta (/stats) : Paris, sans
// attendre villes.json. Avec : la ville de LAgendaVilles, si l'index a repondu.
async function resolveVille(){
  const LV = window.LAgendaVilles;
  if(!PAGE_VILLE || PAGE_VILLE === 'paris' || !LV) return null;
  try { await LV.ready; } catch(_){}
  const v = LV.current();
  return (v && v.slug === PAGE_VILLE) ? v : null;
}

// Ce qui dit Paris dans la page ([data-ville-txt], masques sur une page de
// ville tant que ce n'est pas fait) devient la ville.
function applyWording(){
  if(VILLE){
    const n = VENUES.length;
    const salles = n + ' salle' + (n > 1 ? 's' : '');
    const set = (id, txt) => { const el = document.getElementById(id); if(el) el.textContent = txt; };
    set('scope-src', 'Agenda public');
    set('scope-salles', salles + ' ' + VILLE.a_nom);
    set('bar-salles', salles);
    set('hm-ville', VILLE.nom);
    set('arr-title', 'commune');
    set('arr-active', zoneAllLabel());
    set('foot-salles', salles + ' ' + VILLE.a_nom);
    set('foot-source', 'agenda public');
    document.body.classList.add('stats-ville');
  }
  document.body.classList.add('ville-ok');
}

// ===== PERIODS =====
// Deux modes seulement : total (DB complete) et future (upcoming). Pas d'archives.
function periodLabel(){
  return STATE.period === 'future' ? 'à venir uniquement' : 'programme complet';
}
function periodWindow(){
  const meta = STATE.data.meta || {};
  const range = meta.date_range || {};
  if(STATE.period === 'future'){
    return ymd(STATE.today) + ' → ' + (range.latest || '—');
  }
  return (range.earliest || '—') + ' → ' + (range.latest || '—');
}

// ===== AGREGATIONS =====

// Totaux filtrés par période + genre + arrondissement courant.
function totals(){
  const kpi = STATE.data.kpi_global || {};
  const isFuture = STATE.period === 'future';

  // Par défaut, KPI global via sold_out_by_venue (permet filtre par arr / genre).
  // On a besoin d'un total "cohérent" qui bouge quand on change de filtre.
  const venues = venuesAgg();
  const total  = venues.reduce((s,v)=> s + (v.dates||0), 0);
  const soldC  = venues.reduce((s,v)=> s + (v.soldCount||0), 0);
  const soldPct = total ? Math.round(1000*soldC/total)/10 : 0;
  const active = venues.filter(v => (v.dates||0) > 0).length;

  // Top venue
  const topV = venues.slice().sort((a,b)=>b.dates-a.dates)[0];

  // Top producteur (non filtré par venue/arr/genre — vue globale producteur DB)
  const prods = (STATE.data.producer_market_share || []).slice(0,1);
  const topProd = prods[0] || null;

  return {total, soldC, soldPct, active, topV, topProd, isFuture, kpi};
}

// Retourne l'aggregat par venue pour la periode + arr + genre.
// allZones : sans le filtre arrondissement/commune (compteurs du bloc communes).
function venuesAgg(allZones){
  const isFuture = STATE.period === 'future';
  const arrFilter = STATE.arr; // 'all', '75018' etc. a Paris, une commune ailleurs
  const genreFilter = STATE.genre; // null ou 'Rock'

  const base = {};
  VENUES.forEach(v => {
    base[v.slug] = {slug:v.slug, name:v.dbName, display:v.display, color:v.hex, cap:v.capacity,
                    postal:v.postal, commune:v.commune, zone:zoneOf(v), dates:0, soldCount:0, sold:0};
  });

  // Si un genre est filtre, on part de genre_by_venue qui a (venue, primary_genre, events_count, sold_out_count)
  if(genreFilter){
    (STATE.data.genre_by_venue || []).forEach(row => {
      if(row.primary_genre !== genreFilter) return;
      const v = resolveVenue(row.venue); if(!v) return;
      const slot = base[v.slug]; if(!slot) return;
      // genre_by_venue ne distingue pas futur/total — on applique une ratio approximation
      // en prenant la proportion upcoming/total depuis sold_out_by_venue.
      const allVenueRow = (STATE.data.sold_out_by_venue || []).find(r => (resolveVenue(r.venue) || {}).slug === v.slug);
      let ratio = 1;
      if(isFuture && allVenueRow && allVenueRow.total_events){
        ratio = (allVenueRow.upcoming_events || 0) / allVenueRow.total_events;
      }
      slot.dates     += Math.round((row.events_count || 0) * ratio);
      slot.soldCount += Math.round((row.sold_out_count || 0) * ratio);
    });
  } else {
    (STATE.data.sold_out_by_venue || []).forEach(row => {
      const v = resolveVenue(row.venue); if(!v) return;
      const slot = base[v.slug]; if(!slot) return;
      if(isFuture){
        slot.dates     = row.upcoming_events || 0;
        slot.soldCount = row.upcoming_sold_out || 0;
      } else {
        slot.dates     = row.total_events || 0;
        slot.soldCount = row.sold_out_count || 0;
      }
    });
  }

  // % sold out calculé
  Object.values(base).forEach(v => { v.sold = v.dates ? Math.round(100*v.soldCount/v.dates) : 0; });

  // Filtre arrondissement (après calc — pour que le sold% reste correct par salle)
  let arr = Object.values(base);
  if(arrFilter !== 'all' && !allZones){
    arr = arr.map(v => v.zone === arrFilter ? v : {...v, muted:true, dates:0, soldCount:0, sold:0});
  }
  return arr;
}

// Sous-titre et infobulle d'une salle : arrondissement a Paris, commune ailleurs
// (jauge omise quand le referentiel ne la connait pas).
function venueSub(v){
  if(!VILLE){
    const postalShort = (v.postal||'').startsWith('75') ? (parseInt(v.postal.slice(-2))+'ᵉ') : (v.postal || '—');
    return `${postalShort} · ${fmt(v.cap)} pl.`;
  }
  return esc(v.commune || '—') + (v.cap ? ` · ${fmt(v.cap)} pl.` : '');
}
function venueTipKey(v){
  if(!VILLE) return `${(v.postal||'').startsWith('75')?parseInt(v.postal.slice(-2))+'ᵉ arr.':'—'} · ${fmt(v.cap)} places`;
  return esc(v.commune || '—') + (v.cap ? ` · ${fmt(v.cap)} places` : '');
}

// ===== RENDER · KPI =====
function renderKPIs(){
  const t = totals();
  document.getElementById('period-title').textContent = periodLabel();
  document.getElementById('data-window').textContent = periodWindow();

  document.getElementById('kpi-total').textContent = fmt(t.total);
  document.getElementById('kpi-total-d').innerHTML = STATE.genre
    ? ('genre <b>'+STATE.genre+'</b>')
    : (t.isFuture ? 'fenêtre à venir' : 'programme complet');

  document.getElementById('kpi-sold').textContent = Math.round(t.soldPct);
  document.getElementById('kpi-sold-d').innerHTML = '<b>'+fmt(t.soldC)+'</b> soirs complets';

  document.getElementById('kpi-venues').textContent = t.active;
  document.getElementById('kpi-venues-d').innerHTML = 'salles avec ≥ 1 date';

  document.getElementById('kpi-top-venue').textContent = t.topV ? t.topV.display : '—';
  document.getElementById('kpi-top-venue-d').innerHTML = t.topV
    ? ('<b>'+fmt(t.topV.dates)+'</b> dates · <span class="up">'+(t.topV.sold||0)+'%</span> sold out')
    : '&nbsp;';

  document.getElementById('kpi-producer').textContent = t.topProd ? t.topProd.producer : '—';
  document.getElementById('kpi-producer-d').innerHTML = t.topProd
    ? ('<b>'+fmt(t.topProd.total_events)+'</b> dates · <b>'+t.topProd.market_share_pct+'%</b> du marché')
    : '&nbsp;';

  document.getElementById('strip-count').textContent = fmt(t.total);
}

// ===== RENDER · BAR CHART SALLES =====
function renderBars(){
  const el = document.getElementById('bar-chart');
  let rows = venuesAgg();
  const field = STATE.sort === 'capacity' ? 'cap' : (STATE.sort === 'soldout' ? 'sold' : 'dates');
  rows.sort((a,b)=> (b[field]||0) - (a[field]||0));
  const max = Math.max(1, ...rows.map(r => r[field]||0));

  document.getElementById('bar-sort-label').textContent = STATE.sort === 'volume' ? 'volume' : (STATE.sort === 'soldout' ? '% sold out' : 'capacité');
  document.getElementById('bar-col-label').textContent = STATE.sort === 'capacity' ? 'Capacité' : (STATE.sort === 'soldout' ? '% sold out' : 'Volume');

  const total = rows.reduce((s,r)=>s+(r.dates||0),0);
  document.getElementById('bar-total').textContent = fmt(total);

  if(total === 0 && STATE.sort !== 'capacity'){
    el.innerHTML = '<div class="bar-empty">Pas de données sur cette période.</div>';
    return;
  }

  el.innerHTML = rows.map(v => {
    const val = v[field] || 0;
    const pctW = (val / max) * 100;
    const valLbl = STATE.sort === 'capacity' ? fmt(v.cap) : (STATE.sort === 'soldout' ? (val+'%') : fmt(v.dates));
    const outside = pctW < 18;
    const hi = STATE.focusSlug === v.slug;
    return `
      <div class="bar-row ${v.muted?'muted':''} ${hi?'hi':''}" data-slug="${esc(v.slug)}">
        <div class="nm"><span class="sw" style="background:${v.color}"></span>${esc(v.display)}<small>${venueSub(v)}</small></div>
        <div class="track">
          <div class="bar" style="width:${pctW}%;background:${v.color}"></div>
          <span class="val ${outside?'out':''}" style="left:${outside?pctW:0}%">${valLbl}</span>
        </div>
        <div class="num">${fmt(v.dates)}</div>
        <div class="sold"><b>${v.sold!=null?Math.round(v.sold):'—'}</b>%</div>
      </div>`;
  }).join('');

  el.querySelectorAll('.bar-row').forEach(r => {
    r.addEventListener('mousemove', e => {
      const slug = r.dataset.slug;
      const v = rows.find(x => x.slug === slug); if(!v) return;
      const tt = document.getElementById('tooltip');
      tt.innerHTML = `<span class="k">${venueTipKey(v)}</span><div class="big">${fmt(v.dates)}</div><div class="nm">${esc(v.display)}</div><div class="sub">${v.sold?Math.round(v.sold)+'% sold out':'—'} · click pour détail</div>`;
      tt.classList.add('show');
      tt.style.left = (e.clientX + 14) + 'px';
      tt.style.top  = (e.clientY - 10) + 'px';
    });
    r.addEventListener('mouseleave', () => document.getElementById('tooltip').classList.remove('show'));
    r.addEventListener('click', () => {
      STATE.focusSlug = r.dataset.slug;
      renderBars();
      renderFocus();
      const sel = document.getElementById('focus-select');
      if(sel) sel.value = STATE.focusSlug;
      // scroll doux vers le focus
      document.getElementById('focus-grid').scrollIntoView({behavior:'smooth', block:'start'});
    });
  });
}

// ===== RENDER · TOP PRODUCTEURS =====
function renderProducers(){
  const el = document.getElementById('prod-chart');
  const rows = (STATE.data.producer_market_share || []).slice();
  const isFuture = STATE.period === 'future';

  // Tri
  if(STATE.prodSort === 'volume')  rows.sort((a,b)=> (isFuture? (b.upcoming_events||0) - (a.upcoming_events||0) : (b.total_events||0) - (a.total_events||0)));
  if(STATE.prodSort === 'soldout') rows.sort((a,b)=> (b.producer_sold_out_pct||0) - (a.producer_sold_out_pct||0));
  if(STATE.prodSort === 'reach')   rows.sort((a,b)=> (b.venues_count||0) - (a.venues_count||0));

  document.getElementById('prod-total').textContent = fmt(rows.length);
  document.getElementById('prod-sort-label').textContent = STATE.prodSort === 'volume' ? 'volume' : (STATE.prodSort === 'soldout' ? '% sold out' : 'portée (nb de salles)');
  document.getElementById('prod-col-label').textContent = STATE.prodSort === 'soldout' ? '% sold out' : (STATE.prodSort === 'reach' ? 'Nb de salles' : 'Part de marché');

  // On n'affiche que les 20 premiers pour garder la lisibilite
  const top = rows.slice(0, 20);
  if(!top.length){
    el.innerHTML = '<div class="bar-empty">Pas de producteurs identifiés.</div>';
    return;
  }

  // Max selon tri
  let max;
  if(STATE.prodSort === 'soldout') max = Math.max(1, ...top.map(r => r.producer_sold_out_pct||0));
  else if(STATE.prodSort === 'reach') max = Math.max(1, ...top.map(r => r.venues_count||0));
  else max = Math.max(1, ...top.map(r => (isFuture ? r.upcoming_events : r.total_events) || 0));

  el.innerHTML = top.map(p => {
    let val, displayVal, pctW;
    const dates = isFuture ? (p.upcoming_events||0) : (p.total_events||0);
    if(STATE.prodSort === 'soldout'){
      val = p.producer_sold_out_pct || 0;
      displayVal = val + '%';
    } else if(STATE.prodSort === 'reach'){
      val = p.venues_count || 0;
      displayVal = val + (val>1?' salles':' salle');
    } else {
      val = dates;
      displayVal = p.market_share_pct + '%';
    }
    pctW = (val / max) * 100;
    const outside = pctW < 22;
    return `
      <div class="prod-row" data-producer="${esc(p.producer)}">
        <div class="nm">${esc(p.producer)}<small>${fmt(p.venues_count)} salle${p.venues_count>1?'s':''} · ${p.producer_sold_out_pct}% sold</small></div>
        <div class="track">
          <div class="bar" style="width:${pctW}%"></div>
          <span class="val ${outside?'out':''}" style="left:${outside?pctW:0}%">${displayVal}</span>
        </div>
        <div class="num">${fmt(dates)}</div>
        <div class="sold"><b>${Math.round(p.producer_sold_out_pct)}</b>%</div>
      </div>`;
  }).join('');

  el.querySelectorAll('.prod-row').forEach(r => {
    r.addEventListener('mousemove', e => {
      const p = top.find(x => x.producer === r.dataset.producer); if(!p) return;
      const tt = document.getElementById('tooltip');
      tt.innerHTML = `<span class="k">${fmt(p.venues_count)} salles · part ${p.market_share_pct}%</span><div class="big">${fmt(isFuture?p.upcoming_events:p.total_events)}</div><div class="nm">${esc(p.producer)}</div><div class="sub">${p.producer_sold_out_pct}% sold out</div>`;
      tt.classList.add('show');
      tt.style.left = (e.clientX + 14) + 'px';
      tt.style.top  = (e.clientY - 10) + 'px';
    });
    r.addEventListener('mouseleave', () => document.getElementById('tooltip').classList.remove('show'));
  });
}

// ===== RENDER · FOCUS SALLE =====
function renderFocus(){
  const slug = STATE.focusSlug;
  const grid = document.getElementById('focus-grid');
  const title = document.getElementById('focus-venue-name');
  const sub = document.getElementById('focus-sub');

  if(!slug){
    title.textContent = 'salle';
    sub.textContent = 'Sélectionne une salle dans le graphique ci-dessus ou dans le menu';
    grid.innerHTML = '';
    return;
  }
  const v = V_BY_SLUG[slug];
  if(!v){ grid.innerHTML = ''; return; }

  title.textContent = v.display;
  if(VILLE){
    sub.innerHTML = [esc(v.commune), v.capacity ? `<b>${fmt(v.capacity)}</b> places` : '', esc(v.type)].filter(Boolean).join(' · ');
  } else {
    const postalShort = (v.postal||'').startsWith('75') ? (parseInt(v.postal.slice(-2))+'ᵉ arr.') : (v.postal || '—');
    sub.innerHTML = `${postalShort} · <b>${fmt(v.capacity)}</b> places · ${v.type || ''}`;
  }

  const isFuture = STATE.period === 'future';
  const venueRow = (STATE.data.sold_out_by_venue || []).find(r => (resolveVenue(r.venue)||{}).slug === slug);
  const dates    = venueRow ? (isFuture ? venueRow.upcoming_events : venueRow.total_events) : 0;
  const soldPct  = venueRow ? (isFuture ? (venueRow.upcoming_events ? Math.round(100*venueRow.upcoming_sold_out/venueRow.upcoming_events) : 0) : Math.round(venueRow.sold_out_pct||0)) : 0;

  // Genres à cette salle (top 5)
  const genresAtVenue = (STATE.data.genre_by_venue || [])
    .filter(r => (resolveVenue(r.venue)||{}).slug === slug)
    .sort((a,b)=> (b.events_count||0) - (a.events_count||0))
    .slice(0, 5);

  // Producteurs à cette salle (top 5)
  const prodsAtVenue = (STATE.data.producer_venue_share || [])
    .filter(r => (resolveVenue(r.venue)||{}).slug === slug)
    .sort((a,b)=> (b.events_at_venue||0) - (a.events_at_venue||0))
    .slice(0, 5);

  // Artistes à cette salle — filtrer top_headliners dont la chaîne "venues" contient v.dbName
  const venueNameLower = v.dbName.toLowerCase();
  const artistsAtVenue = (STATE.data.top_headliners || [])
    .filter(r => (r.venues||'').toLowerCase().split(',').map(s=>s.trim()).includes(venueNameLower))
    .slice(0, 5);

  const genreHtml = genresAtVenue.length
    ? `<ul>${genresAtVenue.map(g => `
        <li>
          <div class="lnm">${esc(g.primary_genre)}<small>${g.sold_out_count||0} sold</small></div>
          <div class="lnum"><em>${g.pct_of_venue_total}%</em>${fmt(g.events_count)}</div>
        </li>`).join('')}</ul>`
    : '<div class="empty">Pas de genre documenté</div>';

  const prodHtml = prodsAtVenue.length
    ? `<ul>${prodsAtVenue.map(p => `
        <li>
          <div class="lnm">${esc(p.producer)}<small>${p.pct_of_venue}% du lieu</small></div>
          <div class="lnum">${fmt(p.events_at_venue)}</div>
        </li>`).join('')}</ul>`
    : '<div class="empty">Pas de producteur identifié</div>';

  const artistHtml = artistsAtVenue.length
    ? `<ul>${artistsAtVenue.map(a => `
        <li>
          <div class="lnm">${esc(a.event_name)}<small>${esc(a.genre||'')}</small></div>
          <div class="lnum"><em>${a.total_shows}</em>date${a.total_shows>1?'s':''}</div>
        </li>`).join('')}</ul>`
    : '<div class="empty">Aucune donnée d\'artiste</div>';

  // Adresse : celle du referentiel quand il la connait (villes.json), sinon la commune.
  const metaHtml = VILLE
    ? (v.street ? `<b>${esc(v.street)}</b>` : esc(v.commune))
    : `${v.tagline || ''}<br><b>${v.street || ''}</b> · métro ${v.metro || '—'}`;
  const display = esc(v.display);
  grid.innerHTML = `
    <div class="focus-head">
      <span class="pre"><span class="swf" style="background:${v.hex}"></span>Salle en détail</span>
      <div class="big">${display.split(' ').length > 1 ? display.replace(/ /, ' <em>')+'</em>' : display}</div>
      <div class="meta">${metaHtml}</div>
      <div class="stats">
        <div class="stat"><span class="lbl">Dates</span><span class="v"><em>${fmt(dates)}</em></span></div>
        <div class="stat"><span class="lbl">Sold out</span><span class="v">${soldPct}%</span></div>
        <div class="stat"><span class="lbl">Capacité</span><span class="v">${fmt(v.capacity)}</span></div>
      </div>
    </div>
    <div class="focus-col"><h4>Top genres</h4>${genreHtml}</div>
    <div class="focus-col"><h4>Top producteurs</h4>${prodHtml}</div>
    <div class="focus-col"><h4>Top artistes</h4>${artistHtml}</div>
  `;
}

// ===== RENDER · LINE CHART (mensuel seulement, DB courante) =====
function renderLine(){
  const svg = document.getElementById('line-svg');
  const rows = (STATE.data.seasonality || []).slice();
  // Période future : filtrer à partir du mois courant
  const fromMonth = STATE.period === 'future' ? ymd(STATE.today).slice(0,7) : null;
  const filtered = fromMonth ? rows.filter(r => (r.month||'') >= fromMonth) : rows;

  const labels = filtered.map(r => {
    const [y,m] = (r.month||'').split('-');
    return MONTHS_LBL[parseInt(m)-1] + ' ' + y;
  });
  const primary = filtered.map(r => r.total_events||0);
  const alt     = filtered.map(r => r.sold_out_count||0);

  document.getElementById('line-lg-primary').textContent = STATE.scope === 'sold' ? 'Sold out' : 'Concerts';
  document.getElementById('line-lg-alt').textContent = 'Sold out';
  document.getElementById('line-sub').textContent = 'Agrégation mensuelle · ' + (STATE.period === 'future' ? 'à venir' : 'programme complet');

  if(!primary.length){
    svg.innerHTML = `<text x="700" y="130" text-anchor="middle" font-family="Public Sans" font-size="12" fill="rgba(244,236,222,0.4)">Pas de données</text>`;
    return;
  }

  const W = 1400, H = 260, padL = 44, padR = 16, padT = 22, padB = 32;
  const chartW = W - padL - padR, chartH = H - padT - padB;
  const values = STATE.scope === 'sold' ? alt : primary;
  const max = Math.max(1, Math.max(...primary, ...alt) * 1.1);

  const x = i => padL + (chartW * i / Math.max(values.length - 1, 1));
  const y = v => padT + chartH - (v/max)*chartH;

  const gridLines = [0, 0.25, 0.5, 0.75, 1].map(t => {
    const yy = padT + chartH - t*chartH;
    const v = Math.round(max*t);
    return `<line x1="${padL}" y1="${yy}" x2="${W-padR}" y2="${yy}"/><text x="${padL-8}" y="${yy+3}" text-anchor="end">${fmt(v)}</text>`;
  }).join('');

  const step = Math.max(1, Math.ceil(labels.length / 14));
  const axisX = labels.map((m,i) => (i%step===0 || i===labels.length-1) ? `<text x="${x(i)}" y="${H-10}" text-anchor="middle">${m}</text>` : '').join('');

  const pts   = values.map((v,i)=>`${x(i)},${y(v)}`).join(' ');
  const area  = `M ${padL},${padT+chartH} L ${values.map((v,i)=>`${x(i)},${y(v)}`).join(' L ')} L ${x(values.length-1)},${padT+chartH} Z`;
  const altPts = STATE.scope === 'sold' ? '' : alt.map((v,i)=>`${x(i)},${y(v)}`).join(' ');

  const dots = values.map((v,i)=>`<circle class="line-dot" data-i="${i}" cx="${x(i)}" cy="${y(v)}" r="4"/>`).join('');

  svg.innerHTML = `
    <g class="line-grid">${gridLines}</g>
    <g class="line-axis">${axisX}</g>
    <path class="line-area" d="${area}"/>
    ${STATE.scope !== 'sold' ? `<polyline class="line-line-alt" points="${altPts}"/>` : ''}
    <polyline class="line-line" points="${pts}"/>
    ${dots}
  `;

  svg.querySelectorAll('.line-dot').forEach(d => {
    d.addEventListener('mouseenter', e => {
      const i = +d.dataset.i;
      const tt = document.getElementById('line-tt');
      const rect = svg.getBoundingClientRect();
      const cx = +d.getAttribute('cx'), cy = +d.getAttribute('cy');
      const px = (cx / W) * rect.width, py = (cy / H) * rect.height;
      tt.innerHTML = `<span class="dow">${labels[i]}</span><div class="big">${fmt(primary[i])}</div><div class="nm">concerts · <b>${fmt(alt[i])}</b> sold out</div>`;
      tt.style.left = (px + 14) + 'px';
      tt.style.top  = (py - 50) + 'px';
      tt.classList.add('show');
      svg.querySelectorAll('.line-dot').forEach(x => x.classList.remove('active'));
      d.classList.add('active');
    });
    d.addEventListener('mouseleave', () => {
      document.getElementById('line-tt').classList.remove('show');
      d.classList.remove('active');
    });
  });
}

// ===== RENDER · HEATMAP =====
function heatmapMatrix(){
  const rows = STATE.data.venue_day_matrix || [];
  const M = Array.from({length:7}, ()=> new Array(12).fill(0));
  rows.forEach(r => {
    if(STATE.focusSlug){
      const v = resolveVenue(r.venue);
      if(!v || v.slug !== STATE.focusSlug) return;
    }
    const d = r.day_of_week, m = (r.month_num||1)-1;
    if(d>=0 && d<=6 && m>=0 && m<12) M[d][m] += r.count||0;
  });
  // Reindexer Lundi=0..Dimanche=6 (SQL 0=Dim)
  return [M[1],M[2],M[3],M[4],M[5],M[6],M[0]];
}

function renderHeatmap(){
  const el = document.getElementById('heatmap');
  const M = heatmapMatrix();
  let globalMax = 1, dayMax = new Array(7).fill(1), peakD = 0, peakM = 0, peakV = 0;
  for(let d=0; d<7; d++){
    for(let m=0; m<12; m++){
      const v = M[d][m];
      if(v > globalMax) globalMax = v;
      if(v > dayMax[d]) dayMax[d] = v;
      if(v > peakV){ peakV = v; peakD = d; peakM = m; }
    }
  }

  let html = '<div class="hm-corner">Jour \\ mois</div>';
  for(let m=0; m<12; m++) html += `<div class="hm-h">${MONTHS_LBL[m]}</div>`;
  for(let d=0; d<7; d++){
    html += `<div class="hm-d ${d>=2 && d<=5 ? 'hot':''}">${DAYS_LBL[d]}</div>`;
    for(let m=0; m<12; m++){
      const v = M[d][m];
      let bucket;
      if(STATE.hmMode === 'share' && dayMax[d] > 0){
        bucket = Math.round((v/dayMax[d])*6);
      } else {
        bucket = Math.round((v/globalMax)*6);
      }
      if(d === peakD && m === peakM) bucket = 6;
      const cls = 'v' + Math.max(0, Math.min(6, bucket));
      html += `<div class="hm-c ${cls}" data-d="${d}" data-m="${m}" data-v="${v}"></div>`;
    }
  }
  el.innerHTML = html;

  const peakLabel = peakV ? `${DAYS_LBL[peakD]} · ${MONTHS_LBL[peakM]} · ${fmt(peakV)} concerts` : '—';
  document.getElementById('hm-peak-label').textContent = peakLabel;
  document.getElementById('hm-peak-inline').textContent = peakLabel;

  el.querySelectorAll('.hm-c').forEach(c => {
    c.addEventListener('mousemove', e => {
      const d = +c.dataset.d, m = +c.dataset.m, v = +c.dataset.v;
      const tt = document.getElementById('tooltip');
      tt.innerHTML = `<span class="k">${DAYS_LBL[d]} · ${MONTHS_LBL[m]}</span><div class="big">${fmt(v)}</div><div class="nm">concerts</div>`;
      tt.classList.add('show');
      tt.style.left = (e.clientX + 12) + 'px';
      tt.style.top  = (e.clientY - 10) + 'px';
    });
    c.addEventListener('mouseleave', () => document.getElementById('tooltip').classList.remove('show'));
  });
}

// ===== RENDER · ARRONDISSEMENTS =====
function renderArrs(){
  const el = document.getElementById('arr-sel');
  const rows = venuesAgg();
  const counts = {};
  rows.forEach(v => {
    const postal = v.postal || '';
    if(!postal.startsWith('75')) return;
    const arr = parseInt(postal.slice(-2));
    if(isNaN(arr)) return;
    counts[arr] = (counts[arr]||0) + (v.dates||0);
  });
  const totalAll = rows.reduce((s,r)=>s+(r.dates||0),0);

  let html = `<button class="arr-pill ${STATE.arr==='all'?'active':''}" data-postal="all">Tous<span class="n">${fmt(totalAll)}</span></button>`;
  for(let i=1; i<=20; i++){
    const postal = '750' + String(i).padStart(2,'0');
    const c = counts[i] || 0;
    const has = c > 0;
    html += `<button class="arr-pill ${STATE.arr===postal?'active':''}" data-postal="${postal}" ${!has?'disabled':''}>${i}ᵉ<span class="n">${has?fmt(c):'—'}</span></button>`;
  }
  el.innerHTML = html;

  el.querySelectorAll('.arr-pill').forEach(p => {
    p.addEventListener('click', () => {
      if(p.hasAttribute('disabled')) return;
      STATE.arr = p.dataset.postal;
      document.getElementById('arr-active').textContent = STATE.arr === 'all' ? 'Tous' : (parseInt(STATE.arr.slice(-2))+'ᵉ arr.');
      renderArrs();
      renderBars();
      renderKPIs();
    });
  });
}

// ===== RENDER · COMMUNES (villes hors Paris) =====
// Meme filtre que les arrondissements, par commune de la ville (Villeurbanne,
// Decines… a Lyon). Bloc masque quand toutes les salles sont dans une commune.
// Compteurs sans le filtre commune : changer de commune reste possible.
function renderCommunes(){
  const el = document.getElementById('arr-sel');
  const sect = document.getElementById('arr-sect');
  const communes = [...new Set(VENUES.map(v => v.commune).filter(Boolean))];
  if(sect) sect.hidden = communes.length < 2;
  if(communes.length < 2){ el.innerHTML = ''; return; }
  const rows = venuesAgg(true);
  const counts = {};
  rows.forEach(v => { if(v.zone) counts[v.zone] = (counts[v.zone]||0) + (v.dates||0); });
  const totalAll = rows.reduce((s,r)=>s+(r.dates||0),0);
  communes.sort((a,b)=> (counts[b]||0) - (counts[a]||0) || a.localeCompare(b, 'fr'));

  let html = `<button class="arr-pill ${STATE.arr==='all'?'active':''}" data-zone="all">${zoneAllLabel()}<span class="n">${fmt(totalAll)}</span></button>`;
  communes.forEach(c => {
    const n = counts[c] || 0;
    html += `<button class="arr-pill ${STATE.arr===c?'active':''}" data-zone="${esc(c)}" ${!n && STATE.arr!==c?'disabled':''}>${esc(c)}<span class="n">${n?fmt(n):'—'}</span></button>`;
  });
  el.innerHTML = html;

  el.querySelectorAll('.arr-pill').forEach(p => {
    p.addEventListener('click', () => {
      if(p.hasAttribute('disabled')) return;
      STATE.arr = p.dataset.zone;
      document.getElementById('arr-active').textContent = STATE.arr === 'all' ? zoneAllLabel() : STATE.arr;
      renderCommunes();
      renderBars();
      renderKPIs();
    });
  });
}

function renderZones(){
  if(VILLE) renderCommunes(); else renderArrs();
}

// ===== RENDER · ARTISTES =====
function renderArtists(){
  const el = document.getElementById('art-list');
  const rows = (STATE.data.top_headliners || []).slice(0, 15);
  document.getElementById('artists-sub').textContent = 'Têtes d’affiche programmées';
  if(!rows.length){
    el.innerHTML = '<div class="bar-empty" style="padding:16px 0">Pas de données.</div>';
    return;
  }
  el.innerHTML = rows.map((a,i) => {
    const venues = a.venues ? esc(String(a.venues).split(',').slice(0,2).join(' · ')) : '—';
    const soldOut = a.sold_out_shows ? ` · ${a.sold_out_shows} sold out` : '';
    return `
      <div class="art-row ${i===0?'gold':''}">
        <div class="rk">${String(i+1).padStart(2,'0')}</div>
        <div class="nm"><span>${esc(a.event_name)}</span><small>${venues}${soldOut}</small></div>
        <div class="num">${i===0?'<em>'+a.total_shows+'</em>':a.total_shows}</div>
        <div class="delta ${i===0?'up':''}">${a.venues_count ? a.venues_count+' salle'+(a.venues_count>1?'s':'') : ''}</div>
      </div>`;
  }).join('');
}

// ===== RENDER · GENRES =====
function renderGenres(){
  const el = document.getElementById('genre-list');
  const pillsEl = document.getElementById('genre-pills');
  const rows = (STATE.data.genre_sold_out || []).slice().sort((a,b)=> (b.total_events||0) - (a.total_events||0));
  if(!rows.length){
    el.innerHTML = '<div class="bar-empty" style="padding:16px 0">Pas de données.</div>';
    pillsEl.innerHTML = '';
    return;
  }
  const total = rows.reduce((s,r)=>s+(r.total_events||0), 0);
  const max = Math.max(1, ...rows.map(r => r.total_events||0));
  const palette = ['#E8562C','#F59E32','#B96F9A','#7BA9A6','#C9A44B','#5E9DB6','#6B9A7E','#9C9AA6','#D4623F','#CFB065','#8A9A4F','#E87A62','#D97757','#5E9DB6'];

  el.innerHTML = rows.map((g,i) => {
    const color = palette[i % palette.length];
    const share = total ? Math.round(100*(g.total_events||0)/total) : 0;
    return `
      <div class="genre-row ${STATE.genre===g.primary_genre?'active':''}" data-g="${esc(g.primary_genre)}">
        <div class="nm">${esc(g.primary_genre)}</div>
        <div class="track"><div class="bar" style="width:${(g.total_events||0)/max*100}%;background:${color}"></div></div>
        <div class="num">${share}<small>%</small></div>
      </div>`;
  }).join('');

  pillsEl.innerHTML = `<button class="pill ${STATE.genre===null?'active':''}" data-g="">Tous genres <span class="n">${fmt(total)}</span></button>` + rows.slice(0, 8).map(g => `<button class="pill ${STATE.genre===g.primary_genre?'active':''}" data-g="${esc(g.primary_genre)}">${esc(g.primary_genre)}<span class="n">${fmt(g.total_events||0)}</span></button>`).join('');

  el.querySelectorAll('.genre-row').forEach(r => {
    r.addEventListener('click', () => {
      const g = r.dataset.g;
      STATE.genre = (STATE.genre === g) ? null : g;
      afterGenreChange();
    });
  });
  pillsEl.querySelectorAll('.pill').forEach(p => {
    p.addEventListener('click', () => {
      STATE.genre = p.dataset.g || null;
      afterGenreChange();
    });
  });
}

function afterGenreChange(){
  renderGenres();
  renderBars();
  renderKPIs();
  renderZones();
  if(STATE.focusSlug) renderFocus();
}

// ===== RENDER · FOCUS SELECT =====
function populateFocusSelect(){
  const sel = document.getElementById('focus-select');
  sel.innerHTML = '<option value="">— choisir une salle —</option>' + VENUES
    .slice()
    .sort((a,b)=> a.display.localeCompare(b.display, 'fr'))
    .map(v => `<option value="${esc(v.slug)}" ${STATE.focusSlug===v.slug?'selected':''}>${esc(v.display)}</option>`).join('');
  sel.addEventListener('change', () => {
    STATE.focusSlug = sel.value || null;
    renderBars();
    renderFocus();
    renderHeatmap();
  });
}

// ===== WIRING =====
function wire(){
  document.querySelectorAll('#period-toggle button').forEach(b => {
    b.addEventListener('click', () => {
      document.querySelectorAll('#period-toggle button').forEach(x => x.classList.remove('active'));
      b.classList.add('active');
      STATE.period = b.dataset.p;
      renderAll();
    });
  });
  document.querySelectorAll('#sort-toggle button').forEach(b => {
    b.addEventListener('click', () => {
      document.querySelectorAll('#sort-toggle button').forEach(x => x.classList.remove('active'));
      b.classList.add('active');
      STATE.sort = b.dataset.sort;
      renderBars();
    });
  });
  document.querySelectorAll('#prod-sort-toggle button').forEach(b => {
    b.addEventListener('click', () => {
      document.querySelectorAll('#prod-sort-toggle button').forEach(x => x.classList.remove('active'));
      b.classList.add('active');
      STATE.prodSort = b.dataset.psort;
      renderProducers();
    });
  });
  document.querySelectorAll('#scope-toggle button').forEach(b => {
    b.addEventListener('click', () => {
      document.querySelectorAll('#scope-toggle button').forEach(x => x.classList.remove('active'));
      b.classList.add('active');
      STATE.scope = b.dataset.scope;
      renderLine();
    });
  });
  document.querySelectorAll('#hm-toggle button').forEach(b => {
    b.addEventListener('click', () => {
      document.querySelectorAll('#hm-toggle button').forEach(x => x.classList.remove('active'));
      b.classList.add('active');
      STATE.hmMode = b.dataset.hm;
      renderHeatmap();
    });
  });
  document.getElementById('reset-btn').addEventListener('click', () => {
    STATE.period = 'total'; STATE.genre = null; STATE.arr = 'all';
    STATE.sort = 'volume'; STATE.prodSort = 'volume'; STATE.scope = 'all'; STATE.hmMode = 'count';
    STATE.focusSlug = null;
    document.querySelectorAll('#period-toggle button').forEach(x => x.classList.toggle('active', x.dataset.p === 'total'));
    document.querySelectorAll('#sort-toggle button').forEach(x => x.classList.toggle('active', x.dataset.sort === 'volume'));
    document.querySelectorAll('#prod-sort-toggle button').forEach(x => x.classList.toggle('active', x.dataset.psort === 'volume'));
    document.querySelectorAll('#scope-toggle button').forEach(x => x.classList.toggle('active', x.dataset.scope === 'all'));
    document.querySelectorAll('#hm-toggle button').forEach(x => x.classList.toggle('active', x.dataset.hm === 'count'));
    document.getElementById('arr-active').textContent = zoneAllLabel();
    const sel = document.getElementById('focus-select'); if(sel) sel.value = '';
    renderAll();
  });
}

function renderAll(){
  renderKPIs();
  renderBars();
  renderFocus();
  renderProducers();
  renderLine();
  renderHeatmap();
  renderZones();
  renderArtists();
  renderGenres();
}

// ===== BOOT =====
(async function(){
  // Page de ville : ses fichiers partent tout de suite, en parallele de l'index
  // des villes. Si l'index ne repond pas, la page rendue au build reste telle
  // quelle : jamais l'observatoire de Paris sous le nom d'une autre ville.
  const cityData = (PAGE_VILLE && PAGE_VILLE !== 'paris')
    ? loadAll(DATA_PARIS + 'villes/' + encodeURIComponent(PAGE_VILLE) + '/') : null;
  VILLE = await resolveVille();
  if(!VILLE && cityData) return;
  if(VILLE){
    STATE.data = await cityData;
    indexVenues(cityVenues());
  } else {
    STATE.data = await loadAll(DATA_PARIS);
    indexVenues(typeof VENUES_DATA !== 'undefined' && VENUES_DATA ? VENUES_DATA : []);
  }
  applyWording();
  // Une seule salle (Saint-Avé) : son detail d'emblee, plutot qu'un bloc vide.
  if(VILLE && VENUES.length === 1) STATE.focusSlug = VENUES[0].slug;
  const meta = STATE.data.meta || {};
  if(meta.exported_at){
    const d = new Date(meta.exported_at);
    const fmtD = d.toLocaleDateString('fr-FR', {weekday:'short', day:'2-digit', month:'short'}) + ' · ' + d.toLocaleTimeString('fr-FR', {hour:'2-digit', minute:'2-digit'});
    document.getElementById('data-updated').textContent = fmtD;
    document.getElementById('foot-export').textContent = fmtD;
  }
  populateFocusSelect();
  wire();
  renderAll();
})();

})();
